(function(){

  const MYSTERY_TEE = '5088446546052';
  const VARIANTS    = {
    'S': '34321009442948',
    'M': '34321009475716',
    'L': '34321009508484',
    'XL': '34321009541252',
    'XXL': '34321009574020'
  };

  const form = $('#cart_form');
  const btnUpdate = $('#cart_update_btn');
  const btnSubmit = $('#cart_submit_btn');

  function addMysteryShirt(){

    function mostCommonSize(arr){
      return arr.sort((a,b) => arr.filter(v => v===a).length - arr.filter(v => v===b).length
      ).pop();
    }

    function getShirts(items){
      const wrongIds = Object.values(VARIANTS);
      return items.filter( p => {
        return p.product_type === 'Shirts' && !wrongIds.includes(p.variant_id.toString())
      })
    }

    return new Promise((resolve, reject)=>{
      $.getJSON('/cart.js').then((data)=>{
        const items   = data.items;
        const shirts  = getShirts(items);
        const count   = shirts.map( s => { return s.quantity; } ).reduce((a,b)=> (a+b));
        const varIds  = Object.values(VARIANTS);
        let hasShirt  = false;
        let shirtId   = null;

//        console.log(shirts);

        items.forEach((item)=>{
          const id = item.variant_id.toString();
          console.log(`Checking product id ${id} to see if its included in ${varIds.join(',')}`);
          if( varIds.includes(id) ){
            hasShirt = true;
            shirtId  = id;
          }
          return;
        });

        console.log(`Found ${count} shirt(s).`);

        if( count < 4){
          
          if( hasShirt === false ){
            return resolve();
          }
          
          console.log('Remove existing mystery shirt.');

          $.post('/cart/change.js', {
            id: shirtId,
            quantity: 0
          }, resolve, 'json').fail(reject);
          
          $(`#cart_items #product_${MYSTERY_TEE}`).remove();
          return resolve();
        }

        
        console.log(`Has enough shirts for mystery shirt. ( Included already? ${hasShirt})`);
        
        if( hasShirt === true ){
          return resolve();
        }

        const sizes = [];

        shirts.forEach( s => {
          s.options_with_values.filter( opt => opt.name === "Size" ).forEach( opt => {
            sizes.push(opt.value);
          });
        });

        const sizeValue = mostCommonSize(sizes);
        shirtId = VARIANTS[sizeValue];

        $.post('/cart/add.js', {
          id: shirtId,
          quantity: 1
        }, resolve, 'json').fail(()=>{ reject(); });

        if( $(`#cart_items #product_${MYSTERY_TEE}`).length === 0 ){
          const tpl = $('#mystery_shirt_template').html().replace('ITEM_SIZE', sizeValue);
          $('#cart_items').append(tpl);
        }

        resolve();

      });
    });
  }

  jQuery(document).one('click', '#cart_checkout_btn', (event)=>{
    event.preventDefault();
    const btn = $(event.target);

    addMysteryShirt().then(()=>{
      btn.click();
    }).catch(()=>{
      window.location.reload();
    });

    
  });

  if( jQuery('#cart_items').length ){
    btnUpdate.prop('disabled', true);
    btnSubmit.prop('disabled', true);

    addMysteryShirt().then(()=>{
      btnUpdate.prop('disabled', false);
      btnSubmit.prop('disabled', false);
    }).catch(()=>{
      btnUpdate.prop('disabled', false);
      btnSubmit.prop('disabled', false);
    });
  }




})();